import React, { useEffect, useState } from 'react';
import Card from './ItemCard';

function ItemCardContainer() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch('https://script.google.com/macros/s/AKfycbz30BLk1vrHV68Xy3KmmfVEGQYqWgYWqSJwvXEIZcBfk1E9gawbLKugTqamkDnzvj645w/exec') // Replace with your actual endpoint URL
      .then(response => response.json())
      .then(data => setData(data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  return (
    <div className="App">
      <h1>Family Size Bites</h1>
      <div className="cards-container">
        {data.map((item, index) => (
          <Card key={index} name={item.name} description="Juice" />
        ))}
      </div>
    </div>
  );
}

export default ItemCardContainer;